import { render } from "./WatchVidio.vue?vue&type=template&id=730142ef"
import script from "./WatchVidio.vue?vue&type=script&lang=js"
export * from "./WatchVidio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__